export default "__VITE_ASSET__KFUqk3d8__"